import {
    INDEXABLE_SEO_LANGS,
    METADATA_FALLBACK_LANG,
    normalizeLanguage as normalizeSupportedLanguage
} from "../../Configs/LanguageConfig";

const normalizeLanguage = (language) => normalizeSupportedLanguage(language);

const SEO_ORIGIN = "https://tireshop.lv";

const localizedValue = (
    valuesByLang,
    language,
    fallback = METADATA_FALLBACK_LANG
) => {
    const normalizedLanguage = normalizeLanguage(language);
    const fallbackLanguage = normalizeLanguage(fallback);

    return valuesByLang?.[normalizedLanguage]
        || valuesByLang?.[fallbackLanguage]
        || valuesByLang?.[METADATA_FALLBACK_LANG]
        || "";
};

const localizedPath = (path, language) => {
    const normalizedLanguage = normalizeLanguage(language);
    const url = new URL(path, "https://tireshop.local");

    url.searchParams.set("lang", normalizedLanguage);

    return `${url.pathname}${url.search}${url.hash}`;
};

const localizedAbsoluteUrl = (path, language) => {
    const localized = localizedPath(path, language);

    return `${SEO_ORIGIN}${localized}`;
};

const hreflangLinks = (path, languages = INDEXABLE_SEO_LANGS, includeXDefault = true) => {
    const validLanguages = languages
        .map((language) => normalizeLanguage(language))
        .filter((language, index, all) =>
            INDEXABLE_SEO_LANGS.includes(language) && all.indexOf(language) === index
        );

    const links = validLanguages.map((language) => ({
        hreflang: language,
        href: localizedAbsoluteUrl(path, language)
    }));

    if (includeXDefault) links.push({
        hreflang: "x-default",
        href: localizedAbsoluteUrl(path, "lv")
    });

    return links;
};

export {
    INDEXABLE_SEO_LANGS,
    SEO_ORIGIN,
    hreflangLinks,
    localizedAbsoluteUrl,
    localizedPath,
    localizedValue,
    normalizeLanguage
};
